import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

// Set a default type for the router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export const router = createRouter({ routeTree })
